import React from 'react';
import { CheckCircle2, ShoppingCart, Globe, TrendingUp, BarChart3, Users, MonitorSmartphone } from 'lucide-react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const AppB2BPage = () => {
  const modules = [
    { title: 'Catálogo Digital 24/7', icon: ShoppingCart, items: ['Vitrine online personalizada', 'Produtos com fotos e detalhes', 'Busca inteligente', 'Promoções e destaques'] },
    { title: 'Autoatendimento', icon: Globe, items: ['Emissão de 2ª via de boletos', 'Consulta de histórico de pedidos', 'Acompanhamento de entregas', 'Recompra facilitada'] },
    { title: 'Regras de Negócio', icon: Users, items: ['Tabelas de preços por cliente', 'Condições de pagamento específicas', 'Limite de crédito integrado', 'Estoque em tempo real'] },
    { title: 'Experiência do Cliente', icon: MonitorSmartphone, items: ['Interface responsiva (Web/Mobile)', 'Navegação intuitiva', 'Carrinho de compras ágil', 'Notificações de status'] }
  ];

  return (
    <div>
      <PageHero
        eyebrow="App B2B e-Commerce"
        title="Venda para seus clientes 24 horas por dia."
        subtitle="Um portal de vendas online integrado ao seu ERP para fidelizar clientes e aumentar o ticket médio."
        primaryCta={{ label: 'Ver demonstração', href: '/demonstracao' }}
        secondaryCta={{ label: 'Falar com especialista', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Cenário Atual"
            title="Sua distribuidora aberta o tempo todo"
            description="Não dependa apenas da visita do vendedor. Permita que seu cliente compre quando quiser."
          />
          <div className="grid md:grid-cols-3 gap-6">
            {['Vendedor não consegue visitar todos', 'Cliente precisa repor estoque urgente', 'Custo alto de visita presencial'].map((item) => (
              <Card key={item}>
                <h3 className="text-xl font-semibold">{item}</h3>
                <p className="text-slate-200/80 mt-2">O B2B complementa a força de vendas e captura pedidos nos intervalos das visitas.</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-900/80">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Funcionalidades"
            title="Um e-commerce completo para o atacado"
            description="Recursos desenhados especificamente para a complexidade das vendas B2B."
          />
          <div className="grid md:grid-cols-2 gap-6">
            {modules.map((module) => (
              <Card key={module.title}>
                <div className="flex items-center gap-3 mb-3">
                  <module.icon className="w-6 h-6 text-[#FF6B35]" />
                  <h3 className="text-xl font-semibold">{module.title}</h3>
                </div>
                <ul className="space-y-1 text-sm text-slate-200/80">
                  {module.items.map((item) => (
                    <li key={item} className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 h-4 text-[#FF6B35]" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white text-slate-900">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Integração Total"
            title="Conectado ao seu ERP Zartoo"
            description="Sem retrabalho: pedidos caem direto no sistema, estoque baixa na hora e financeiro é atualizado."
            mode="light"
          />
          <div className="grid md:grid-cols-3 gap-6">
            {['Sincronização instantânea', 'Estoque real', 'Financeiro automático'].map((item) => (
              <Card key={item} variant="light">
                <TrendingUp className="w-6 h-6 text-[#1976D2]" />
                <h3 className="text-xl font-semibold mt-3">{item}</h3>
                <p className="text-slate-600 mt-2">Elimine a digitação de pedidos e erros de comunicação.</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16 text-center">
          <SectionTitle
            eyebrow="Resultados Esperados"
            title="+15% vendas adicionais • Redução do custo de venda"
            description="Aumente a capilaridade da sua distribuidora com um canal de vendas digital."
          />
          <a
            href="/demonstracao"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-black text-lg bg-[#FF6B35] text-white hover:shadow-orange-500/40 transition-all"
          >
            Quero conhecer o B2B
          </a>
        </div>
      </section>
    </div>
  );
};

export default AppB2BPage;
